import { VIEW_EVENT_AFTER_VIEW_NAME_CHANGE } from '../../view/viewEventTypes';

// (DataSourceNode, String) -> Promise[void]
export const updateCurrentViewName = async (qRulesDataSource, viewName) => {
    const viewNode = qRulesDataSource.selectSingle('/*/View[@current]');

    if (!viewNode) {
        return;
    }

    const currentAttr = viewNode.selectSingle('@current');
    const previousAttr = viewNode.selectSingle('@previous');

    const lastValue = currentAttr.value();

    await currentAttr.setValueAsync(viewName);
    await previousAttr?.setValueAsync(lastValue);
};

// (DataSourceNode, ViewManager) -> Promise[void]
export const registerViewNameTracker = async (
    qRulesDataSource,
    viewManager,
) => {
    const action = () =>
        updateCurrentViewName(qRulesDataSource, viewManager.getCurrentView());

    viewManager.addEventListener(VIEW_EVENT_AFTER_VIEW_NAME_CHANGE, action);

    // as of this writing, view name in view manager is set before qRules is iniitalized, so
    // need to populate the view name manually the first time around
    await action();
};
